import React from 'react';
import SEO from './SEO';
import DrivewayEstimator from './DrivewayEstimator';
import HouseWashEstimator from './HouseWashEstimator';
import MiniContactForm from './MiniContactForm';

function Pricing() {
  return (
    <main key="pricing-page" className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <SEO 
        title="Pricing | Copper Canyon Pressure Wash"
        description="Get transparent pricing for pressure washing services in Phoenix and surrounding areas. Use our calculator to estimate your project cost."
        keywords="pressure washing pricing, cost, estimate, Phoenix, exterior cleaning, Copper Canyon Pressure Wash, free quote, calculator"
      />
      <section className="mb-12 text-center">
        <h1 className="text-4xl font-bold text-[#4a3f35] mb-4">Pricing & Estimates</h1>
        <p className="text-lg text-gray-700 max-w-2xl mx-auto">
          Get transparent pricing for all our pressure washing services. <span className="font-semibold text-[#b87c4c]">For the most accurate quote, call us at <a href="tel:6027300728" className="underline hover:text-[#a06940]">(602) 730-0728</a> to speak with an agent.</span> Use the calculator below for a quick estimate, or contact us for a custom quote tailored to your needs.
        </p>
      </section>
      {/* Estimator Tools */}
      <section className="mb-16">
        <h2 className="text-2xl font-semibold text-[#b87c4c] mb-4">Driveway Estimator</h2>
        <DrivewayEstimator />
      </section>
      <section>
        <h2 className="text-2xl font-semibold text-[#b87c4c] mb-4">Exterior House Wash Estimator</h2>
        <HouseWashEstimator />
      </section>
      <div className="max-w-2xl mx-auto mt-16 mb-12">
        <MiniContactForm />
      </div>
    </main>
  );
}

export default Pricing; 